import { makeStyles } from '@fluentui/react-components';
import React from 'react';
import { Link, Outlet } from 'react-router-dom';
import { slThemeLight } from '../slTheme';
import { SiteHeader } from './SiteHeader';
import { withStyles, withStylesAndMsalContext } from "./withStyles";
import { IAppContext } from "../model/IAppContext";
import { TheAppContext } from "../model/AppContext";
import { IMsalContext } from '@azure/msal-react';

export interface LayoutProps
{
    styles: Record<string, string>;
    msalContext: IMsalContext;
}

export interface LayoutState
{
}

const useStyles = makeStyles(
    {
        link:
        {
            textTransform: 'uppercase',
            fontSize: slThemeLight.fontSizeBase400,
            lineHeight: slThemeLight.lineHeightBase400,
            padding: '20pt'
        }
    });

export class LayoutWithoutStyles extends React.Component<LayoutProps, LayoutState>
{
    context!: IAppContext;
    static contextType = TheAppContext;

    async componentDidMount()
    {
    }

    render()
    {
        return (
            <div>
                <SiteHeader/>
                <div>
                    <Outlet/>
                </div>
                <div>
                    <Link className={this.props.styles.link} to="/">Home</Link> |
                    <Link className={this.props.styles.link} to="/SmokeItPage">SmokeIt</Link>
                </div>
            </div>
        );
    }
}

export const Layout = withStylesAndMsalContext(useStyles, LayoutWithoutStyles);